<template>
  <div class="inner-net-container">
    <span class="el-icon-cloudy cloud" title="使用云端JSON文件数据" @click="useCloudJson"></span>
    <span class="iconfont icon-json json" title="切换JSON视图" @click="showJsonHandle"></span>
    <span class="el-icon-check submit" title="保存数据" @click="setInnerNet"></span>
    <div v-show="!showJson">
      <h4 class="title">内网地址</h4>
      <el-card class="net-card" ref="net-card">
        <el-form :model="ipForm" ref="ipForm" label-width="100px" class="form">
          <el-form-item class="form-item" v-for="(item, index) in ipForm.ips" :label="'IP地址' + index" :key="item.key" :prop="'ips.' + index + '.ip'" :rules="ipFormRules">
            <el-input v-model="item.ip" :style="{width:'85%'}"></el-input>
            <span class="btn-box">
              <i class="el-icon-circle-plus-outline add-icon" title="新增" @click.stop="addIP"></i>
              <i class="el-icon-delete delete-icon" title="删除" @click.stop="removeIP(item)"></i>
            </span>
          </el-form-item>
        </el-form>
      </el-card>
      <h4 class="title">内网网段</h4>
      <el-card class="segment-card" ref="segment-card">
        <el-form v-show="networkSegmentForm.networkSegments.length" :model="networkSegmentForm" ref="networkSegmentForm" label-width="100px" class="form">
          <el-form-item class="form-item" v-for="(item, index) in networkSegmentForm.networkSegments" :label="'网段地址' + index" :key="item.key" :prop="'networkSegments.' + index + '.ns'" :rules="networkSegmentFormRules">
            <el-input placeholder="请输入内容" v-model="item.ns" :style="{width:'85%'}">
              <el-select v-model="item.sl" slot="append" placeholder="请选择" :style="{width:'80px'}">
                <el-option label="/8" value="/8">/8</el-option>
                <el-option label="/16" value="/16">/16</el-option>
                <el-option label="/24" value="/24">/24</el-option>
              </el-select>
            </el-input>
            <span class="btn-box">
              <i class="el-icon-circle-plus-outline add-icon" title="新增" @click.stop="addNetworkSegment"></i>
              <i class="el-icon-delete delete-icon" title="删除" @click.stop="removeNetworkSegment(item)"></i>
            </span>
          </el-form-item>
        </el-form>
        <div v-show="!networkSegmentForm.networkSegments.length" class="add-ns" @click="addNetworkSegment">
          <i class="el-icon-plus"></i>
        </div>
      </el-card>
    </div>
    <div class="json-container" v-show="showJson">
      <json-viewer :value="jsonData" :expand-depth="5" copyable boxed sort expanded></json-viewer>
    </div>

  </div>
</template>

<script>
import { systemApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading';
import axios from 'axios';
let validateIP = (rule, value, callback) => {
  if (/^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/.test(value)) {
    callback()
  } else {
    callback(new Error('请输入正确的IP地址！'))
  }
}
export default {
  name: 'inner-net-setting',
  data () {
    return {
      showJson: false,
      jsonData: {},
      ipForm: {
        ips: [
          { ip: '', key: Date.now() }
        ]
      },
      ipFormRules: [
        {
          required: true, message: 'IP地址不能为空', trigger: 'blur'
        },
        { validator: validateIP, trigger: 'blur' }
      ],
      networkSegmentForm: {
        networkSegments: [
          { ns: '', sl: '/16', key: Date.now() }
        ]
      },
      networkSegmentFormRules: [
        { required: true, message: '网段地址不能为空', trigger: 'blur' },
        { validator: validateIP, trigger: 'blur' }
      ],
    }
  },
  mounted () {
    this.getInnerNet();
  },
  methods: {
    // 使用云端Json文件数据
    async useCloudJson () {
      const { data } = await axios.get('https://front-xps-cdn.xsyx.xyz/custom/xps/static/json/innerNet.json');
      if (data) {
        this.initInnerNetData(data);
      } else {
        this.$message.error('JSON文件加载失败！');
      }
    },
    // 获取内网地址
    async getInnerNet () {
      showLoading();
      const { data, code } = await systemApi.getInnerNet();
      if (code === 200 && data) {
        this.initInnerNetData(data);
      }
      hideLoading();
    },
    // 初始化内网数据
    initInnerNetData (data) {
      if (data.ips.length) {
        const ips = [];
        data.ips.forEach((item, index) => {
          ips.push({
            ip: item,
            key: Date.now() + index
          });
        });
        this.ipForm.ips = ips;
      }
      if (data.networkSegments.length) {
        const networkSegments = [];
        data.networkSegments.forEach((item, index) => {
          const ns = item.split('/')[0];
          const sl = `/${item.split('/')[1]}`
          networkSegments.push(
            { ns, sl, key: Date.now() + index }
          );
        });
        this.networkSegmentForm.networkSegments = networkSegments;
      } else {
        this.networkSegmentForm.networkSegments = [];
      }
      this.initJsonViewer();
    },
    // 切换视图
    showJsonHandle () {
      this.initJsonViewer();
      this.showJson = !this.showJson;
    },
    // 初始化json显示
    initJsonViewer () {
      const ips = [];
      this.ipForm.ips.forEach(item => {
        ips.push(item.ip);
      })
      const networkSegments = this.networkSegmentForm.networkSegments.map(item => {
        return item.ns ? item.ns + item.sl : '';
      })
      this.jsonData = { ips, networkSegments };
      return this.jsonData;
    },
    // 设置内网地址
    setInnerNet () {
      this.$refs['ipForm'].validate(async (valid) => {
        this.$refs['networkSegmentForm'].validate(async (valid1) => {
          if (valid && valid1) {
            const innerNet = this.initJsonViewer();
            const data = await systemApi.setInnerNet({ innerNet });
            if (data.code === 200) {
              this.$message.success(data.message);
            } else {
              this.$message.error(data.message);
            }
          } else {
            return false;
          }
        })
      })
    },
    // 新增IP地址
    addIP () {
      this.ipForm.ips.push({
        ip: '',
        key: Date.now()
      });
      this.$nextTick(() => {
        this.$refs['net-card'].$el.scrollTo(0, 10000)
      })


    },
    // 新增网段地址
    addNetworkSegment () {
      this.networkSegmentForm.networkSegments.push(
        { ns: '', sl: '/16', key: Date.now() }
      );
      this.$nextTick(() => {
        this.$refs['segment-card'].$el.scrollTo(0, 10000)
      })
    },
    // 移除IP地址
    removeIP (item) {
      if (this.ipForm.ips.length > 1) {
        let index = this.ipForm.ips.indexOf(item)
        if (index !== -1) {
          this.ipForm.ips.splice(index, 1)
        }
      } else {
        this.$message.warning('已经是最后一个IP地址了！无法删除哦~');
      }
    },
    // 移除网段地址
    removeNetworkSegment (item) {
      let index = this.networkSegmentForm.networkSegments.indexOf(item)
      if (index !== -1) {
        this.networkSegmentForm.networkSegments.splice(index, 1)
      }
    },
  }
}
</script>

<style lang="scss">
.inner-net-container {
  position: relative;
  max-height: 720px;
  overflow: auto;
  .json-container {
    margin-top: 60px;
  }
  .cloud,
  .submit,
  .json {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 10px;
    right: 10px;
    padding: 8px;
    font-size: 18px;
    font-weight: 700;
    color: #5862ab;
    border: 1px solid #ebeef5;
    border-radius: 50%;
    opacity: 0.6;
    transition: all 0.3s ease;
    &:hover {
      transform: scale(1.5);
      color: #409eff;
    }
  }
  .cloud {
    right: 102px;
  }
  .json {
    right: 56px;
  }
  .title {
    text-align: center;
  }
  .net-card {
    height: 400px;
    overflow-y: auto;
  }
  .segment-card {
    max-height: 200px;
    overflow-y: auto;
  }
  .form {
    .form-item {
      padding: 15px 0;
      margin-bottom: 0;
      border-radius: 6px;
      .btn-box {
        margin-left: 10px;
        .add-icon,
        .delete-icon {
          display: none;
          padding: 8px;
          color: #5862ab;
          font-size: 14px;
          font-weight: 700;
          border-radius: 50%;
          background-color: #fff;
          opacity: 0.6;
          transition: all 0.3s ease;
        }
        .add-icon {
          &:hover {
            transform: scale(1.5);
            color: #67c23a;
          }
        }
        .delete-icon {
          margin-left: 10px;
          &:hover {
            transform: scale(1.5);
            color: red;
          }
        }
      }
    }
    .form-item:hover {
      background-color: #ecf5ff;
      .btn-box {
        .add-icon,
        .delete-icon {
          display: inline-block;
        }
      }
    }
  }
  .add-ns {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    cursor: pointer;
    line-height: 146px;
    vertical-align: top;
    text-align: center;
    &:hover {
      border: 1px dashed #409eff;
    }
    i {
      font-size: 28px;
      color: #5862ab;
    }
  }
}
</style>